export const environment = {
    apiURL:"https://devapi.nesiyatova.com/api"
};